module.exports = __webpack_public_path__ + "static/media/nuget.e3846298.svg";